import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import settings from '../../../assets/aws.settings.json';

@Injectable({
  providedIn: 'root'
})
export class AwsService {

  constructor() {
    AWS.config.update({
      region: settings.region,
      credentials: new AWS.CognitoIdentityCredentials({
          IdentityPoolId: settings.identityPoolId
      })
    });
  }

  uploadFileToS3(bucket, key, file) {
    const upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: bucket,
          Key: key,
          Body: file
        }
    });

    const promise = upload.promise();
    return promise;
  }
}
